import React, { Component, Fragment } from 'react';
import { DocumentFieldText } from 'components/cards/document/preview/DocumentFieldText';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import FieldsGroup from 'components/cards/document/fields/FieldsGroup';
import { getValue, xmlArrayToObj, checkGroup } from 'helpers/documentsHelpers';

export default class InterviewRecruiter extends Component {
    info = checkGroup(({ documentResponsible, candidate }) => (
        <FieldsGroup translate="recomendation">
            <DefinitionField translate="xml.PplVerRek.documentResponsible" show={!!documentResponsible}>
                <DocumentFieldText
                    name="xml.PplVerRek.documentResponsible"
                    value={documentResponsible}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.Candidate" show={!!candidate}>
                <DocumentFieldText
                    name="xml.PplVerRek.Candidate"
                    value={candidate}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    forLineMenager = checkGroup(({ managerFio, clientCompany }) => (
        <FieldsGroup translate="forLineManager">
            <DefinitionField translate="xml.PplVerRek.CLIENTFIO" show={!!managerFio}>
                <DocumentFieldText
                    name="xml.PplVerRek.CLIENTFIO"
                    value={managerFio}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.CLIENTCOMP" show={!!clientCompany}>
                <DocumentFieldText
                    name="xml.PplVerRek.CLIENTCOMP"
                    value={clientCompany}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    recommender = checkGroup(({ recomFio, recomCompany, recomPosition, recomContacts }) => (
        <FieldsGroup translate="recommender">
            <DefinitionField translate="xml.PplVerRek.recomFio" show={!!recomFio}>
                <DocumentFieldText
                    name="xml.PplVerRek.recommenderFio"
                    value={recomFio}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.REKOMCOMP" show={!!recomCompany}>
                <DocumentFieldText
                    name="xml.PplVerRek.REKOMCOMP"
                    value={recomCompany}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.REKOMDOLG" show={!!recomPosition}>
                <DocumentFieldText
                    name="xml.PplVerRek.REKOMDOLG"
                    value={recomPosition}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.REKOMPHONE" show={!!recomContacts}>
                <DocumentFieldText
                    name="xml.PplVerRek.REKOMPHONE"
                    value={recomContacts}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    coopWorkPeriod = checkGroup(({ howLongKnow, whenWork, coopRecomPosition }) => (
        <FieldsGroup translate="coopWorkPeriod">
            <DefinitionField translate="xml.PplVerRek.HOWLONGKNOW" show={!!howLongKnow}>
                <DocumentFieldText
                    name="xml.PplVerRek.HOWLONGKNOW"
                    value={howLongKnow}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHENWORK" show={!!whenWork}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHENWORK"
                    value={whenWork}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.REKNAME" show={!!coopRecomPosition}>
                <DocumentFieldText
                    name="xml.PplVerRek.REKNAME"
                    value={coopRecomPosition}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    subordinationSystem = checkGroup(({ chief, relations, recruitment, start }) => (
        <FieldsGroup translate="subordinationSystem">
            <DefinitionField translate="xml.PplVerRek.WASREKCHIEF" show={!!chief}>
                <DocumentFieldText
                    name="xml.PplVerRek.WASREKCHIEF"
                    value={chief}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHATREKOTN" show={!!relations}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHATREKOTN"
                    value={relations}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.YOUDECIDEPRIM" show={!!recruitment}>
                <DocumentFieldText
                    name="xml.PplVerRek.YOUDECIDEPRIM"
                    value={recruitment}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.HOWLONGSTART" show={!!start}>
                <DocumentFieldText
                    name="xml.PplVerRek.HOWLONGSTART"
                    value={start}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    mainTasks = checkGroup(({ mainTasks, mainFunctions }) => (
        <FieldsGroup translate="mainTasks">
            <DefinitionField translate="xml.PplVerRek.WHATTASK" show={!!mainTasks}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHATTASK"
                    value={mainTasks}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHATFUNC" show={!!mainFunctions}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHATFUNC"
                    value={mainFunctions}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    workResults = checkGroup(({ result, achievements, contribution, targetResult, coWorkerResult }) => (
        <FieldsGroup translate="workResults">
            <DefinitionField translate="xml.PplVerRek.MARK" show={!!result}>
                <DocumentFieldText
                    name="xml.PplVerRek.MARK"
                    value={result}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.ACHIEVE" show={!!achievements}>
                <DocumentFieldText
                    name="xml.PplVerRek.ACHIEVE"
                    value={achievements}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.VKLAD" show={!!contribution}>
                <DocumentFieldText
                    name="xml.PplVerRek.VKLAD"
                    value={contribution}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.RESULT" show={!!targetResult}>
                <DocumentFieldText
                    name="xml.PplVerRek.RESULT"
                    value={targetResult}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.CMPRESULT" show={!!coWorkerResult}>
                <DocumentFieldText
                    name="xml.PplVerRek.CMPRESULT"
                    value={coWorkerResult}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    strength  = checkGroup(({ strength }) => (
        <FieldsGroup translate="strength">
            <DefinitionField translate="xml.PplVerRek.STRONG" show={!!strength}>
                <DocumentFieldText
                    name="xml.PplVerRek.STRONG"
                    value={strength}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    managment = checkGroup(({ persons, chiefCharact, solution, peopleEmployment }) => (
        <FieldsGroup translate="managment">
            <DefinitionField translate="xml.PplVerRek.WASCHIEF" show={!!persons}>
                <DocumentFieldText
                    name="xml.PplVerRek.WASCHIEF"
                    value={persons}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHATCHIEF" show={!!chiefCharact}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHATCHIEF"
                    value={chiefCharact}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WASSAMOST" show={!!solution}>
                <DocumentFieldText
                    name="xml.PplVerRek.WASSAMOST"
                    value={solution}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WASTRUDO" show={!!peopleEmployment}>
                <DocumentFieldText
                    name="xml.PplVerRek.WASTRUDO"
                    value={peopleEmployment}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    weakSides = checkGroup(({ tasks, qualities }) => (
        <FieldsGroup translate="weakSides">
            <DefinitionField translate="xml.PplVerRek.DIF" show={!!tasks}>
                <DocumentFieldText
                    name="xml.PplVerRek.DIF"
                    value={tasks}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.NOTSTRONG" show={!!qualities}>
                <DocumentFieldText
                    name="xml.PplVerRek.NOTSTRONG"
                    value={qualities}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    peopleRelations = checkGroup(({ collectiveRelations, conflict, clientRelations }) => (
        <FieldsGroup translate="peopleRelations">
            <DefinitionField translate="xml.PplVerRek.WITHCHIEF" show={!!collectiveRelations}>
                <DocumentFieldText
                    name="xml.PplVerRek.WITHCHIEF"
                    value={collectiveRelations}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WITHKOLLEGA" show={!!conflict}>
                <DocumentFieldText
                    name="xml.PplVerRek.WITHKOLLEGA"
                    value={conflict}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WITHOUT" show={!!clientRelations}>
                <DocumentFieldText
                    name="xml.PplVerRek.WITHOUT"
                    value={clientRelations}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    workAttitude = checkGroup(({ workAttitude, factors, stimulus, stress }) => (
        <FieldsGroup translate="workAttitude">
            <DefinitionField translate="xml.PplVerRek.HOWWORK" show={!!workAttitude}>
                <DocumentFieldText
                    name="xml.PplVerRek.HOWWORK"
                    value={workAttitude}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHYSTESS" show={!!factors}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHYSTESS"
                    value={factors}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHATOUTFAKTOR" show={!!stimulus}>
                <DocumentFieldText
                    name="xml.PplVerRek.WHATOUTFAKTOR"
                    value={stimulus}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.STIMUL" show={!!stress}>
                <DocumentFieldText
                    name="xml.PplVerRek.STIMUL"
                    value={stress}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    futureLeader = checkGroup(({ futureLeader }) => (
        <FieldsGroup translate="workAttitude">
            <DefinitionField translate="xml.PplVerRek.WHATFUTURECHIEF">
                <DocumentFieldText
                    name="xml.PplVerRek.WHATFUTURECHIEF"
                    value={futureLeader}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    dismissalReasons = checkGroup(({ leaveRaason, goOutReason }) => (
        <FieldsGroup translate="dismissalReasons">
            <DefinitionField translate="xml.PplVerRek.WHYGO">
                <DocumentFieldText
                    name="xml.PplVerRek.WHYGO"
                    value={leaveRaason}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WHUWILLGO">
                <DocumentFieldText
                    name="xml.PplVerRek.WHUWILLGO"
                    value={goOutReason}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    workDesire = checkGroup(({ takeToWork, workTogether }) => (
        <FieldsGroup translate="workDesire">
            <DefinitionField translate="xml.PplVerRek.WANTHIMCOMMENT">
                <DocumentFieldText
                    name="xml.PplVerRek.WANTHIMCOMMENT"
                    value={takeToWork}
                />
            </DefinitionField>
            <DefinitionField translate="xml.PplVerRek.WANTHIMKOLLEGA">
                <DocumentFieldText
                    name="xml.PplVerRek.WANTHIMKOLLEGA"
                    value={workTogether}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    workCompliance = checkGroup(({ workCompliance }) => (
        <FieldsGroup translate="complianceFutureWork">
            <DefinitionField translate="xml.PplVerRek.WHYYOUREKOM">
                <DocumentFieldText
                    name="xml.PplVerRek.WHYYOUREKOM"
                    value={workCompliance}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    additionalInformation = checkGroup(({ additionalInformation }) => (
        <FieldsGroup translate="additionalInformation">
            <DefinitionField translate="xml.PplVerRek.ADDINFORM">
                <DocumentFieldText
                    name="xml.PplVerRek.ADDINFORM"
                    value={additionalInformation}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    yourQuestion = checkGroup(({ yourQuestion }) => (
        <FieldsGroup translate="yourQuestion">
            <DefinitionField translate="xml.PplVerRek.ADDQUESTION">
                <DocumentFieldText
                    name="xml.PplVerRek.ADDQUESTION"
                    value={yourQuestion}
                />
            </DefinitionField>
        </FieldsGroup>
    ));

    render() {
        const { xml } = this.props;
        const xmlObject = xmlArrayToObj(xml);

        return (
            <Fragment>
                {this.info({
                    documentResponsible: getValue(xmlObject.Employee),
                    candidate: getValue(xmlObject.Candidate)
                })}
                {this.forLineMenager({
                    managerFio: getValue(xmlObject.CLIENTFIO),
                    clientCompany: getValue(xmlObject.CLIENTCOMP)
                })}
                {this.recommender({
                    recomFio: getValue(xmlObject.REKOMFIO),
                    recomCompany: getValue(xmlObject.REKOMCOMP),
                    recomPosition: getValue(xmlObject.REKOMDOLG),
                    recomContacts: getValue(xmlObject.REKOMPHONE)
                })}
                {this.coopWorkPeriod({
                    howLongKnow: getValue(xmlObject.HOWLONGKNOW),
                    whenWork: getValue(xmlObject.WHENWORK),
                    coopRecomPosition: getValue(xmlObject.REKNAME),
                })}
                {this.subordinationSystem({
                    chief: getValue(xmlObject.WASREKCHIEF),
                    relations: getValue(xmlObject.WHATREKOTN),
                    recruitment: getValue(xmlObject.YOUDECIDEPRIM),
                    start: getValue(xmlObject.HOWLONGSTART),
                })}
                {this.mainTasks({
                    mainTasks: getValue(xmlObject.WHATTASK),
                    mainFunctions: getValue(xmlObject.WHATFUNC),
                })}
                {this.workResults({
                    result: getValue(xmlObject.MARK),
                    achievements: getValue(xmlObject.ACHIEVE),
                    contribution: getValue(xmlObject.VKLAD),
                    targetResult: getValue(xmlObject.RESULT),
                    coWorkerResult: getValue(xmlObject.CMPRESULT),
                })}
                {this.strength({
                    strength: getValue(xmlObject.STRONG),
                })}
                {this.managment({
                    persons: getValue(xmlObject.WASCHIEF),
                    chiefCharact: getValue(xmlObject.WHATCHIEF),
                    solution: getValue(xmlObject.WASSAMOST),
                    peopleEmployment: getValue(xmlObject.WASTRUDO),
                })}
                {this.weakSides({
                    tasks: getValue(xmlObject.DIF),
                    qualities: getValue(xmlObject.NOTSTRONG),
                })}
                {this.peopleRelations({
                    collectiveRelations: getValue(xmlObject.WITHCHIEF),
                    conflict: getValue(xmlObject.WITHKOLLEGA),
                    clientRelations: getValue(xmlObject.WITHOUT),
                })}
                {this.workAttitude({
                    workAttitude: getValue(xmlObject.HOWWORK),
                    factors: getValue(xmlObject.WHYSTESS),
                    stimulus: getValue(xmlObject.WHATOUTFAKTOR),
                    stress: getValue(xmlObject.STIMUL),
                })}
                {this.futureLeader({
                    futureLeader: getValue(xmlObject.WHATFUTURECHIEF),
                })}
                {this.dismissalReasons({
                    leaveRaason: getValue(xmlObject.WHYGO),
                    goOutReason: getValue(xmlObject.WHUWILLGO),
                })}
                {this.workDesire({
                    takeToWork: getValue(xmlObject.WANTHIMCOMMENT),
                    workTogether: getValue(xmlObject.WANTHIMKOLLEGA),
                })}
                {this.workCompliance({
                    workCompliance: getValue(xmlObject.WHYYOUREKOM),
                })}
                {this.additionalInformation({
                    additionalInformation: getValue(xmlObject.ADDINFORM),
                })}
                {this.yourQuestion({
                    yourQuestion: getValue(xmlObject.ADDQUESTION),
                })}
            </Fragment>
        );
    }
}
